import { ErrorMessage, ErrorMessageProps } from "./ErrorMessage";

export type Error500Props = Omit<
  ErrorMessageProps,
  "title" | "description" | "showBackButton"
>;

export const Error500 = (props: Error500Props) => {
  return (
    <ErrorMessage
      {...props}
      title="Internal Server Error"
      description="Sorry, it seems Layer is having issues serving this page. Our engineers have been notified of the issue and will be working to resolve it as soon as possible."
      showBackButton={
        false /* Note: Careful, this component is used in the ErrorBoundary, so it cannot depend on the router */
      }
    />
  );
};
